import { useDemoMode } from '../../hooks/useDemoMode.js';

/**
 * A pill fixed to the bottom of every page on the demo deployment, so nobody mistakes it for
 * their real account. It lets clicks through, so it never covers a control.
 */
export function DemoBanner() {
  if (!useDemoMode()) return null;
  return (
    <div
      role="status"
      style={{
        position: 'fixed', bottom: 12, left: '50%', transform: 'translateX(-50%)',
        zIndex: 'var(--z-toast)' as unknown as number, pointerEvents: 'none',
        background: 'var(--warning-surface)', color: 'var(--warning-text)',
        border: '1px solid var(--warning-border)', borderRadius: 999,
        padding: '6px 14px', fontSize: 'var(--text-xs)', fontWeight: 'var(--font-semibold)',
        whiteSpace: 'nowrap', boxShadow: 'var(--shadow-md)',
      }}
    >
      Demo environment: emails go to the demo inbox
    </div>
  );
}
